// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
}
.quantity-selector > * {
  line-height: var(--quantity-selector-height);
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  background-color: var(--color-light-gray);
  border: 1px solid var(--ion-color-primary);
  font-family: AppFontSemiBold;
  font-size: 24px;
  line-height: 28.8px;
  text-align: center;
  color: var(--color-light-primary);
}
.circle.minus {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.circle.plus {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.rectangle {
  background-color: var(--color-light-gray);
  border-top: 1px solid var(--ion-color-primary);
  border-bottom: 1px solid var(--ion-color-primary);
  color: var(--color-light-primary);
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
  font-family: AppFontSemiBold;
  font-size: var(--quantity-font-size);
  line-height: 28.8px;
  text-align: center;
}

ion-icon {
  height: 100%;
  width: 100%;
}
ion-icon:active {
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,oDAAA;AACD;AACC;EAEC,4CAAA;EACA,UAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAaA;EACC,sCAAA;EACA,uCAAA;EACA,eAAA;EACG,yCAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;AAVJ;AAaE;EACE,2BAAA;EACA,8BAAA;AAXJ;AAcE;EACE,4BAAA;EACA,+BAAA;AAZJ;;AAgBA;EACI,yCAAA;EACA,8CAAA;EACA,iDAAA;EACH,iCAAA;EACA,gDAAA;EACA,uCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAdD;;AAiBA;EACC,YAAA;EACA,WAAA;AAdD;AAgBC;EACC,YAAA;AAdF","sourcesContent":[".quantity-selector {\n\tdisplay: flex;\n\tfont-size: calc(var(--quantity-selector-height) / 2);\n\n\t> * {\n\t\t// background: #c6aa7a;\n\t\tline-height: var(--quantity-selector-height);\n\t\tpadding: 0;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t// &:first-child {\n\t\t// \tborder-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\n\t\t// &:last-child {\n\t\t// \tborder-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\t}\n}\n\n.circle {\n\twidth: var(--quantity-selector-height);\n\theight: var(--quantity-selector-height);\n\tcursor: pointer;\n    background-color: var(--color-light-gray);\n    border: 1px solid var(--ion-color-primary);\n    font-family: AppFontSemiBold;\n    font-size: 24px;\n    line-height: 28.8px;\n    text-align: center;\n    color: var(--color-light-primary);\n\n\n  &.minus {\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n\n  &.plus {\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n}\n\n.rectangle {\n    background-color: var(--color-light-gray);\n    border-top: 1px solid var(--ion-color-primary);\n    border-bottom: 1px solid var(--ion-color-primary);\n\tcolor: var(--color-light-primary);\n\twidth: calc(1 * var(--quantity-selector-height));\n\theight: var(--quantity-selector-height);\n\n\tfont-family: AppFontSemiBold;\n\tfont-size: var(--quantity-font-size);\n\tline-height: 28.8px;\n\ttext-align: center;\n}\n\nion-icon {\n\theight: 100%;\n\twidth: 100%;\n\n\t&:active {\n\t\topacity: 0.6;\n\t}\n}\n\n.cart-screen {\n\t> * {\n\t\t// background: #f1efea;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
